/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QueueParamsDto { 
    queue: QueueParamsDto.QueueEnum;
}
export namespace QueueParamsDto {
    export const QueueEnum = {
        scheduled: 'scheduled',
        priority: 'priority'
    } as const;
    export type QueueEnum = typeof QueueEnum[keyof typeof QueueEnum];
}


